import React, { useState } from 'react'
import { AllOthersComponent } from '../Other/AllOthersComponent';
import { Button, Col, Row } from 'antd';
import { addButton } from '../../assets/styles/stylesMain';
import { AddOthersComponent } from '../Other/AddOthersComponent';
import {
  PlusOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
// ======================================================================
export const OthersComponent = ({
  setLoading,
  printType,
  showMessage,
  mode,
  reserveId,
  reserve,
  period,
  onPrimaryAdded,
  showTitleBar = false }) => {
  // ======================================================================
  const [view, setView] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);
  const [version, setVersion] = useState(0);
  // ======================================================================
  return (
    <>
    
      <AllOthersComponent
        setLoading={setLoading}
        printType = {printType}
        showMessage={showMessage}
        reserveId={reserveId}
        reserve={reserve}
        version={version}
        currentPage={currentPage}
        period={period}
        setCurrentPage={setCurrentPage}
        isShowDelete={mode == 'Edit'}
        onRowDeleted={() => { setVersion(version + 1); }}
      />

      {view === "Add" ? (
        <AddOthersComponent
          setLoading={setLoading}
          showMessage={showMessage}
          reserveId={reserveId}
          period={period}
          rowInserted={() => {
            setView("All"); if (currentPage != 1)
              setCurrentPage(1);
            else
              setVersion(version + 1);
          }}
          cancelInsert={() => { setView("All"); }}
          onPrimaryAdded={onPrimaryAdded}
        />
      ) :
        (
          mode == 'Edit' ?
            <>
              <Row style={{ padding: '10px' }}>
                <Col xs={12} sm={12} md={18} lg={21} xl={21} >
                </Col>
                <Col xs={12} sm={12} md={6} lg={4} xl={4} >
                <Button className='btn-success' onClick={() => { setView("Add") }} style={{ width: '95%' }}> <PlusOutlined /> فرد جدید</Button>

                </Col>
              </Row>

            </> : <></>
        )
      }
    </>
  )

}
